import { useContext, useState } from 'react'
import appContext from 'context/appContext'
import { WppIconBoard, WppIconGear, WppIconTaskList, WppTypography } from '@wppopen/components-library-react'
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom'
import UnsavedChangesModal from 'components/Modals/UnsavedChangesModal/UnsavedChangesModal'
import clsx from 'clsx'
import logoUrl from 'assets/logo.svg'
import styles from './Header.module.scss'

export const Header = () => {
  const { hasUnsavedChanges, setHasUnsavedChanges } = useContext(appContext)
  const [isTryingToQuitWithChanges, setIsTryingToQuitWithChanges] = useState(false)
  const [pendingNavigation, setPendingNavigation] = useState<string>()
  const { pathname } = useLocation()
  const navigate = useNavigate()

  // this had to be done because of the "save changes" modal when someone tries to navigate away from the product form page
  const onLinkClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (hasUnsavedChanges) {
      e.preventDefault()
      setPendingNavigation(e.currentTarget.pathname)
      setIsTryingToQuitWithChanges(true)
    }
  }

  const handleSubmit = () => {
    if (pendingNavigation) {
      setHasUnsavedChanges(false)
      setIsTryingToQuitWithChanges(false)
      setPendingNavigation(undefined)
      navigate(pendingNavigation)
    }
    return
  }

  const primaryMenu = [
    {
      label: 'Projects',
      icon: <WppIconBoard slot="icon-start" />,
      value: 'projects',
      path: '/projects',
    },
    {
      label: 'Tasks',
      icon: <WppIconTaskList slot="icon-start" />,
      value: 'tasks',
      path: '/tasks',
    },
    {
      label: 'Settings',
      icon: <WppIconGear slot="icon-start" />,
      value: 'settings',
      path: '/settings',
    },
  ]

  return (
    <>
      <header className={styles.header}>
        <div className={styles.header__container}>
          <Link to="/" onClick={onLinkClick}>
            <div className={styles.__logoContainer}>
              <img src={logoUrl} alt="logo" />
              <WppTypography className={styles.wppTopBarTitle} type="m-strong" tag="h3">
                PDP Generator
              </WppTypography>
            </div>
          </Link>

          {!!primaryMenu.length && (
            <nav>
              {primaryMenu.map(({ icon, label, path, value }) => (
                <NavLink
                  key={label}
                  to={path!}
                  onClick={onLinkClick}
                  data-testid={`nav-link-${value}`}
                  className={({ isActive }) =>
                    clsx(
                      styles.navLink,
                      pathname === '/' && value === 'projects'
                        ? styles.activeNavLink
                        : isActive && styles.activeNavLink,
                    )
                  }
                >
                  {icon} {label}
                </NavLink>
              ))}
            </nav>
          )}
        </div>
      </header>

      {isTryingToQuitWithChanges && (
        <UnsavedChangesModal
          onCancel={() => {
            setPendingNavigation(undefined)
            setIsTryingToQuitWithChanges(false)
          }}
          shouldModalOpen={isTryingToQuitWithChanges}
          handleSubmit={() => handleSubmit()}
        />
      )}
    </>
  )
}
